﻿document.addEventListener('DOMContentLoaded', function() {
  if (window.location.hash === '#contact_form') {
    var successEl = document.querySelector('.retractation-success');
    var formEl = document.querySelector('.retractation-form');
    if (successEl) successEl.style.display = 'block';
    if (formEl) formEl.style.display = 'none';
    history.replaceState(null, '', window.location.pathname + window.location.search);
    return;
  }

  var form = document.querySelector('.retractation-form');
  if (!form) return;

  var submitBtn = document.getElementById('retractation-submit');
  var fields = form.querySelectorAll('[required]');

  function validateField(field) {
    var errorEl = field.parentElement.querySelector('.form-field__error');
    var isValid = true;

    if (!field.value.trim()) {
      isValid = false;
    } else if (field.type === 'email') {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailPattern.test(field.value.trim());
    } else if (field.hasAttribute('minlength')) {
      var minLen = parseInt(field.getAttribute('minlength'));
      isValid = field.value.trim().length >= minLen;
    } else if (field.hasAttribute('pattern')) {
      var pattern = new RegExp('^' + field.getAttribute('pattern') + '$');
      isValid = pattern.test(field.value.trim());
    }

    if (errorEl) {
      errorEl.style.display = isValid ? 'none' : 'block';
    }
    field.classList.toggle('input--error', !isValid);
    return isValid;
  }

  function validateForm() {
    var allValid = true;
    fields.forEach(function(field) {
      if (!validateField(field)) {
        allValid = false;
      }
    });
    submitBtn.disabled = !allValid;
    return allValid;
  }

  fields.forEach(function(field) {
    field.addEventListener('blur', function() { validateField(field); validateForm(); });
    field.addEventListener('input', function() { validateField(field); validateForm(); });
  });

  var parentForm = form.closest('form');
  if (parentForm) {
    parentForm.addEventListener('submit', function(e) {
      if (!validateForm()) {
        e.preventDefault();
      }
    });
  }
});
